import { render, staticRenderFns } from "./ComplaintList.vue?vue&type=template&id=1e5c81a8&"
import script from "./ComplaintList.vue?vue&type=script&lang=js&"
export * from "./ComplaintList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports